import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const PanelAuction = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [userId, setUserId] = useState("");


    // Load user data from localStorage
    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");
        const storedUserId = localStorage.getItem("userId");

        console.log("LocalStorage Values:", {
            storedUserType,
            storedUserId,
            storedUserName,
            storedFName,
            storedLName,
        });

        if (!storedUserType || !storedUserId || !storedUserName) {
            console.warn("Missing critical localStorage data, redirecting to login");
            localStorage.clear();
            navigate("/login");
            return;
        }

        setUserType(storedUserType);
        setUserName(storedUserName);
        setUserId(storedUserId);
        if (storedFName && storedLName) {
            setUserFullName(`${storedFName} ${storedLName}`);
        } else if (storedFName) {
            setUserFullName(storedFName);
        } else {
            setUserFullName(storedUserName);
        }
    }, [navigate]);

    const logout = () => {
        localStorage.clear(); // Ensure all data is cleared
        navigate("/login");
    };
    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3>Admin panel auction page</h3>

                    <div className="auction-container">
                        <iframe id="myIframe" src="https://auc.onejp.net/aj_neo?classic" allowfullscreen></iframe>
                    </div>

                </div>

            </div>

        </div>
    );
};

export default PanelAuction;